import { type ComboboxItem } from '@mantine/core';
import { type Mapping } from '../API/GET/mapping/response';

export function MappingToComboBoxItem(
  mapping: Mapping | undefined
): ComboboxItem[] {
  if (!mapping) return [];
  return Object.entries(mapping).map(
    ([key, value]): ComboboxItem => ({
      label: value,
      value: key,
    })
  );
}
